import {} from 'react';

const GoalTransaction = ({ color, size }: { color?: string; size?: number }) => (
  <svg
    width={size || 40}
    height={size || 40}
    viewBox="0 0 80 80"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    color={color}
  >
    <path d="M44.8 19.2c-.3-.3-.8-.3-.8.4v10.3c0 .7-.5 1.2-1.1 1.2H29.1C22 31 22 34.6 22 36.8c0 .8.6 1.2 1.4 1.2h42.1c.5 0 .7-.5.3-.8l-21-18zm-9.6 41.6c.3.3.8.3.8-.4V50.2c0-.7.5-1.2 1.1-1.2h13.7c7.1 0 7.1-3.6 7.1-5.8 0-.8-.6-1.2-1.4-1.2h-42c-.5 0-.7.5-.3.8l21 18z" />
  </svg>
);

export default GoalTransaction;
